// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.client.boost.enums.CustomerAnalyticsBoostMediaChannel

export enum CustomerAnalyticsBoostMediaChannel {
  META = 'META',
  TIKTOK = 'TIKTOK',
}

export const CustomerAnalyticsBoostMediaChannel_values = [
  CustomerAnalyticsBoostMediaChannel.META,
  CustomerAnalyticsBoostMediaChannel.TIKTOK,
] as const;
